import { all, select, takeEvery, fork, put, call } from 'redux-saga/effects'

// action
import { masterdataActions } from '@redux/store/index'

// api
import { masterdataApi, ResType } from '@api'

// lib
import { Logger } from '@utils'

import type { MainMasterdataType } from '@redux/types'
import dayjs from 'dayjs'

const apiGetMainMaster = async () => {
	const res: ResType | undefined = await masterdataApi.getMainMasterdata()
	return res
}

function* triggerGetMainMasterdataSaga() {
	try {
		const masterdata: MainMasterdataType = yield select(
			state => state.masterdata.mainMasterdata,
		)

		const today = dayjs().format('YYYY-MM-DD')

		if (
			masterdata.exchangeRate === 0 ||
			masterdata.fedexFuelSurchargeRate === 0 ||
			masterdata.issuedDate == '' ||
			masterdata.issuedDate !== today
		) {
			const apiRes: ResType = yield call(apiGetMainMaster)

			if (apiRes.status === 200) {
				const exchangeRate: number = apiRes.data[0].exchangeRate
				const fedexFuelSurchargeRate: number = apiRes.data[0].fedexFuelSurchargeRate
				const issuedDate: string = apiRes.data[0].issuedDate
				yield put(
					masterdataActions.MAIN_MAINMASTER_DATA({
						exchangeRate: exchangeRate,
						fedexFuelSurchargeRate: fedexFuelSurchargeRate,
						issuedDate: issuedDate,
					}),
				)
			}
		}
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(
		masterdataActions.TRIGGER_GET_MAIN_MASTER_DATA,
		triggerGetMainMasterdataSaga,
	)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
